import siderTrigger from './sider-trigger.vue'
export default siderTrigger



// WEBPACK FOOTER //
// ./src/components/main/components/header-bar/sider-trigger/index.js